import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, dark = false }) => (
  <div className="mb-12 md:mb-16">
    <p
      className="text-xs md:text-sm uppercase tracking-[0.25em] font-semibold text-[#BFA26F] mb-4"
      data-testid={`overline-${overline.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {overline}
    </p>
    <h2
      className={`font-display text-3xl md:text-4xl lg:text-5xl font-medium leading-tight max-w-3xl ${
        dark ? "text-[#FBF9F6]" : "text-[#111413]"
      }`}
    >
      {title}
    </h2>
    <div className="mt-6 h-px w-24 bg-[#BFA26F]" />
  </div>
);
